// components/Permission.js
import { useContext } from 'react';
import { AuthContext } from 'State/AuthContext';

const Permission = ({ resource, actions = [], children }) => {
    const { entitlements } = useContext(AuthContext);

    // No resource defined → open to any authenticated user (mirrors useHasAccess)
    if (!resource) return <>{children}</>;

    // Ensure the resource is found in the entitlements
    const resourceEntitlement = entitlements?.find((entitlement) => entitlement.name === resource);

    // If the resource entitlement exists and the user has the required action
    const allowedActions = resourceEntitlement?.entitlements || [];
    const hasPermission = actions.some((action) =>
        allowedActions.includes(action) || allowedActions.includes('*')
    );

    // If the user doesn't have permission, return null, meaning nothing will render
    if (!hasPermission) return null;

    // Otherwise, render the children components
    return <>{children}</>;
};

export default Permission;
